import { useQuery } from '@tanstack/react-query';
import { ListingSuggestedItemsApiClient } from 'api/listingSuggestedItems';
import { ListingSuggestedItemsModel } from 'models';

export function useListingSuggestedItems(listingId: string, enabled: boolean = true) {
  return useQuery<ListingSuggestedItemsModel>({
    queryKey: ['listing-suggested-items', listingId],
    queryFn: () => ListingSuggestedItemsApiClient.getSuggestedItems(listingId),
    enabled: enabled && !!listingId,
  });
}
